import styled, { css } from "styled-components"
import { media } from "utils/Media"

const TitleBar = styled.div`
    opacity: 1;
    position: relative;
    z-index: 21;
    border: 4px solid ${props => props.theme.colors.white};
    
    ${props => props.color === 'yellow' && css`
        background-color: ${props => props.theme.colors.yellow};
    `}
    
    ${props => props.color === 'darkGrey' && css`
        background-color: ${props => props.theme.colors.darkGrey};
    `}
    
    ${props => props.color === 'orange' && css`
        background-color: ${props => props.theme.colors.orange};
    `}
    
    ${props => props.color === 'purple' && css`
        background-color: ${props => props.theme.colors.purple};
        color: ${props => props.theme.colors.white};
    `}
    
    ${props => props.color === 'red' && css`
        background-color: ${props => props.theme.colors.red};
    `}
    
    ${props => props.color === 'green' && css`
        background-color: ${props => props.theme.colors.green};
    `}
    
    ${props => props.color === 'blue' && css`
        background-color: ${props => props.theme.colors.blue};
    `}
    
    ${props => props.absolute && css`
        position: absolute;
        width: 100%;
        left: 50%;
        transform: translateX(-50%);
        top: -56px;
        
        @media ${media.sm} {
          top: -48px;
        }
    `}
      
    h2 {
        font-family: ${props => props.theme.font.family.medium}; 
        letter-spacing: 0.03em;
        text-align: center;
        font-size: 2rem;
        line-height: 100%;
        margin: 0;
        padding: 0.5rem;
        
        @media ${media.sm} {
            font-size: 3.125rem;
        }
    }
    
     ${props => props.textWhite && css`
        h2 {
            color: ${props => props.theme.colors.white};
        }
    `}
    
    ${props => props.lessPadding && css`
        border-bottom: none;
    `}
`

export default TitleBar